import { copy } from "stylis";

// eslint-disable-next-line no-undef
const MeowSettings = mwl_settings;

const apiUrl = MeowSettings.api_url;
const restNonce = MeowSettings.rest_nonce;

const selector = MeowSettings.settings.selector;
const anti_selector = MeowSettings.settings.anti_selector;
const theme = MeowSettings.settings.theme;
const flat_orientation = MeowSettings.settings.flat_orientation;
const slideshow = {
  enabled: MeowSettings.settings.slideshow.enabled,
  slide_duration: MeowSettings.settings.slideshow.timer,
  autoplay: MeowSettings.settings.slideshow.autoplay,
};
// Still in development
const thumbnails_navigation = {
  enabled: false,
  height: 200,
};
const preloading = MeowSettings.settings.preloading; // not in use;
const magnification = {
  enabled: MeowSettings.settings.magnification,
};
const full_screen = {
  enabled: MeowSettings.settings.full_screen,
  start_desktop: MeowSettings.settings.full_screen_start_desktop,
  start_mobile: MeowSettings.settings.full_screen_start_mobile,
};
const backdrop_opacity = MeowSettings.settings.backdrop_opacity;
const map = MeowSettings.settings.map;
const caption_source = MeowSettings.settings.caption_source;
const caption_ellipsis = MeowSettings.settings.caption_ellipsis;
const low_res_placeholder = MeowSettings.settings.low_res_placeholder;
const wordpress_big_image = MeowSettings.settings.wordpress_big_image;
const deep_linking = MeowSettings.settings.deep_linking;
const deep_linking_slug = MeowSettings.settings.deep_linking_slug;
const disable_scroll = true;
const separate_galleries = MeowSettings.settings.separate_galleries;
const disable_arrows_on_mobile = MeowSettings.settings.disable_arrows_on_mobile;
const animation_toggle = MeowSettings.settings.animation_toggle;
const animation_speed = MeowSettings.settings.animation_speed;
const rtf_slider_fix = MeowSettings.settings.rtf_slider_fix;

const social_sharing = MeowSettings.settings.social_sharing;
const social_sharing_platforms = [
  { label: 'Facebook', path: 'https://www.facebook.com/sharer/sharer.php?u=', enabled: MeowSettings.settings.social_sharing_facebook },
  { label: 'Twitter/X', path: 'https://twitter.com/intent/tweet?text=', enabled: MeowSettings.settings.social_sharing_twitter },
  { label: 'Pinterest', path: 'https://pinterest.com/pin/create/button/?url=', enabled: MeowSettings.settings.social_sharing_pinterest },
];

const infos_to_display = {
  title: MeowSettings.settings.exif.title,
  caption: MeowSettings.settings.exif.caption,
  camera: MeowSettings.settings.exif.camera,
  date: MeowSettings.settings.exif.date,
  time: MeowSettings.settings.exif.time,
  lens: MeowSettings.settings.exif.lens,
  shutter_speed: MeowSettings.settings.exif.shutter_speed,
  aperture: MeowSettings.settings.exif.aperture,
  focal_length: MeowSettings.settings.exif.focal_length,
  iso: MeowSettings.settings.exif.iso,
  keywords: MeowSettings.settings.exif.keywords,
  metadata_toggle: MeowSettings.settings.exif.metadata_toggle,
  copyright: MeowSettings.settings.exif.copyright,
  author: MeowSettings.settings.exif.author,
};

const metadata_toggle = {
  enabled: MeowSettings.settings.exif.metadata_toggle,
  start_hidden: MeowSettings.settings.exif.metadata_toggle_start_hidden,
};

const download = {
  enabled: MeowSettings.settings.download_link,
};
const right_click_protection = MeowSettings.settings.right_click_protection;
const js_logs = MeowSettings.settings.js_logs;

const animation_speeds = {
  very_fast: 150,
  fast: 300,
  normal: 500,
  slow: 700,
  very_slow: 1000,
}

const include_orphans = MeowSettings.settings.include_orphans;
const skip_dynamic_fetch = MeowSettings.settings.skip_dynamic_fetch;

export { selector, anti_selector, theme, flat_orientation, slideshow, thumbnails_navigation, preloading,
  magnification, full_screen, backdrop_opacity, map, caption_source, caption_ellipsis, low_res_placeholder, wordpress_big_image, deep_linking, deep_linking_slug, disable_scroll,
  social_sharing, social_sharing_platforms, separate_galleries, disable_arrows_on_mobile, animation_toggle, animation_speed, animation_speeds, infos_to_display, download, right_click_protection, rtf_slider_fix, include_orphans, skip_dynamic_fetch, js_logs, apiUrl, restNonce, metadata_toggle };